<template>
  <div v-if="vehicle && vehicle.gallery" class="gallery">
    <div
      v-for="(image, index) in vehicle.gallery"
      :key="image.id"
      :class="{ '-on': index === current }"
      class="gallery__img"
    >
      <img
        :alt="image.label"
        :src="imageManager().picture(image.url, 'tv_zoom')"
      />
    </div>
    <div class="control">
      <button
        v-for="(image, index) in vehicle.gallery"
        :key="image.id"
        :class="{ '-on': index === current }"
        class="control__button"
        @click="toggle(index)"
      >
        <img
          :alt="image.label"
          :src="imageManager().picture(image.url, 'tv_min')"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store";
import { imageManager } from "@/services/image-manager";

export default {
  name: "GalleryView",
  data() {
    return {
      current: 0,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
      ranges: (store) => store.ranges,
    }),
  },
  watch: {
    ranges() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    imageManager() {
      return imageManager;
    },
    init() {
      const rangeId = this.$route.params.range;
      this.toggleRange(rangeId);
      this.toggleVehicle(this.$route.params.vehicle);
    },

    toggle(index) {
      this.current = index;
    },

    ...mapActions(useMainStore, ["toggleRange", "toggleVehicle"]),
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  width: 100%;
  height: 100%;
  position: relative;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: all 1000ms ease-in-out;

    &.-on {
      opacity: 1;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.control {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: $white;
  width: 114px;
  padding: 10px 15px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);

  &__button {
    width: 150%;
    position: relative;
    right: 50%;
    height: auto;
    border: none;
    background: none;
    transition: all 300ms ease-in-out;
    transform-origin: right;
    transform: scale(0.65);
    padding: 0;
    margin-top: -5px;
    margin-bottom: -5px;

    &.-on {
      transform: scale(1);
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
      margin: 10px 0;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 16/9;
    }
  }
}
</style>
